<template>
  <div class="wrap" v-loading="allLoading">
    <div class="main-wrap my-orders">
      <!-- 导航 -->
      <div class="order-navigation">
        <a
          class="text1"
          href="/#/catalogue"
        >{{L.home}}</a>
        <span class="line">/</span>
        <a
          class="text2"
          href="/#/auth" 
        >{{L.authentication}}</a>
      </div>
      <!-- 我的订单-标题 -->
      <div class="my-orders-title">
        <span class="title">{{L.authentication}}</span>
        <span class="iconfont icon-flag" v-if="status<=2">&#xe62e;</span>
        <span class="iconfont icon-flag" v-if="status==3">&#xe631;</span>
      </div>
      <div class="tab">
        <div class="square-wrap" :class="{'square-wrap-active-half':status==0,'square-wrap-active':status>=1}">
          <div class="rule-square">
            <span class="text">
              <span class="iconfont icon-num" v-if="status==0">&#xe762;</span>
              <span class="iconfont icon-num icon-num2" v-if="status>=1">&#xe66e;</span>
              <span class="text-info">{{L.basicInfo}}</span>
            </span>
            <span class="right-triangle"></span>
          </div>
        </div>
        <div class="square-wrap" :class="{'square-wrap-active-half':status==1,'square-wrap-active':status>=2}">
          <div class="rule-square">
            <span class="text">
              <span class="iconfont icon-num" v-if="status==1">&#xe763;</span>
              <span class="iconfont icon-num icon-num2" v-if="status>=2">&#xe66e;</span>
              <span class="text-info">{{L.bankInfo}}</span>
            </span>
            <span class="left-triangle"></span>
            <span class="right-triangle"></span>
          </div>
        </div>
        <div class="square-wrap" :class="{'square-wrap-active-half':status==2,'square-wrap-active':status>=3}">
          <div class="rule-square">
            <span class="text">
              <span class="iconfont icon-num" v-if="status==2">&#xe764;</span>
              <span class="iconfont icon-num icon-num2" v-if="status>=3">&#xe66e;</span>
              <span class="text-info">{{L.amountVerification}}</span>
            </span>
            <span class="left-triangle"></span>
            <span class="right-triangle"></span>
          </div>
        </div>
        <div class="square-wrap" :class="{'square-wrap-active':status==3}">
          <div class="rule-square">
            <span class="text">
              <!-- <span class="iconfont icon-num">&#xe792;</span> -->
              <span class="iconfont icon-num icon-num2" v-if="status==3">&#xe66e;</span>
              <span class="text-info">{{L.authSuccessful}}</span>
            </span>
            <span class="left-triangle"></span>
          </div>
        </div>
      </div>
      <div class="info-wrap">
        <div class="sub-title">
          <div class="left">
            <span class="iconfont icon-info">&#xe626;</span>
            <span class="info-text">{{L.basicInfo}}</span>
          </div>
          <div class="right" v-if="status==0">
            <span class="btn" @click="showBasic">{{L.enterBasicInfo}}</span>
          </div>
          <div class="right" v-if="status==2">
            <span class="btn" @click="showVerify">{{L.verifyAmount}}</span>
          </div>
        </div>
        <div class="basic-info-wrap">
          <div class="line">
            <div class="square">
              <div class="text-title">{{L.companyCode}}:</div>
              <div class="text-value">{{info.dealerCode}}</div>
            </div>
            <div class="square">
              <div class="text-title">{{L.companyName}}:</div>
              <div class="text-value">{{info.dealerName}}</div>
            </div>
            <div class="square">
              <div class="text-title">{{L.companyID}}:</div>
              <div class="text-value">{{info.taxNumber}}</div>
            </div>
            
          </div>
          <div class="line">
            <div class="square">
              <div class="text-title">{{L.legalPersonName}}:</div>
              <div class="text-value">{{info.legalName}}</div>
            </div>
            <div class="square">
              <div class="text-title">{{L.legalPersonID}}:</div>
              <div class="text-value">{{info.legalIdcard}}</div>
            </div>
            <div class="square"></div>
          </div>
        </div>
      </div>
      <div class="info-wrap info-wrap2">
        <div class="sub-title">
          <div class="left">
            <span class="iconfont icon-info">&#xe632;</span>
            <span class="info-text">{{L.bankInfo}}</span>
          </div>
          <div class="right" v-if="status==1">
            <span class="btn" @click="showBank">{{L.enterBankInfo}}</span>
          </div>
        </div>
        <div class="basic-info-wrap">
          <div class="line">
            <div class="square">
              <div class="text-title">{{L.companyAccountName}}:</div>
              <div class="text-value">{{info.accountName}}</div>
            </div>
            <div class="square">
              <div class="text-title">{{L.bankAccountNumber}}:</div>
              <div class="text-value">{{info.bankAccount}}</div>
            </div>
            <div class="square">
              <div class="text-title">{{L.provinceBank}}:</div>
              <div class="text-value">{{info.province}}</div>
            </div> 
          </div>
          <div class="line">
            <div class="square">
              <div class="text-title">{{L.cityBank}}:</div>
              <div class="text-value">{{info.city}}</div>
            </div>
            <div class="square">
              <div class="text-title">{{L.bankName}}:</div>
              <div class="text-value">{{info.bankName}}</div>
            </div>
            <div class="square">
              <div class="text-title">{{L.fullNameBank}}:</div>
              <div class="text-value">{{info.bankFullname}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹窗 -->
    <Basic ref="Basic" @getAuth="getAuth"/>
    <Bank ref="Bank" @getAuth="getAuth"/>
    <Verify ref="Verify" @getAuth="getAuth"/>
  </div>
</template>

<script>
import {api_auth_info} from '@/api/api'
import {postAction} from '@/api/tool'
import Basic from './Basic'
import Bank from './Bank'
import Verify from './Verify'

export default {
  name:'Auth',
  components:{
    Basic,
    Bank,
    Verify
  },
  data(){
    return {
      status:0,
      info:{
        dealerCode:'',
        dealerName:'',
        taxNumber:'',
        legalName:'',
        legalIdcard:'',
        accountName:'',
        bankAccount:'',
        province:'',
        city:'',
        bankName:'',
        bankFullname:''
      }
    }
  },
  methods:{
    getAuth(){
      this.allLoading=true
      postAction(api_auth_info).then(res=>{
        this.allLoading=false
        this.status=res.status
        this.info=res
      }).catch(()=>{
        this.allLoading=false
      })
    },
    showBasic(){
      this.$refs.Basic.open(this.info)
    },
    showBank(){
      this.$refs.Bank.open(this.info)
    },
    showVerify(){
      this.$refs.Verify.open()
    }
  },
  mounted(){
    this.getAuth()
  }
}
</script>

<style lang="less" scoped>
@import url('/public/css/public.less');
@import url('./index.less');
</style>

